import { Size } from '@ps/web-core-enums';
import { useScreenSize } from '@ps/web-shared-components';
import React from 'react';

import WebpWithFallback from '@swf/components/WebpWithFallback/WebpWithFallback';

import { useHomeGamesWidget } from '../../../model';
import topTearPNG from '../assets/top-tear.png';
import topTear from '../assets/top-tear.webp';

import styles from './Steps.scss';

export const Steps: React.FC = () => {
  const { widgetConfig } = useHomeGamesWidget();
  const {
    landing_section: {
      steps: { first_step: firstStep, second_step: secondStep, third_step: thirdStep }
    }
  } = widgetConfig;
  const stepContent = [firstStep, secondStep, thirdStep];
  const { greaterThan } = useScreenSize();

  const isMobileDevice = !greaterThan(Size.Medium);

  return (
    <>
      {isMobileDevice && (
        <WebpWithFallback
          src={topTear}
          srcFallback={topTearPNG}
          containerClassName={styles.tear}
          imageSize={{ height: 1280, width: 97 }}
        />
      )}
      <section className={styles.steps}>
        <div className={styles.inner}>
          {stepContent.map((step, index) => (
            <div key={step.step_title} className={styles.step}>
              <div className={styles.left}>{index + 1}</div>
              <div className={styles.right}>
                <div className={styles.title}>{step.step_title}</div>
                <div className={styles.text}>{step.step_description}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};
